import React from 'react'
import 'react-quill/dist/quill.snow.css'
import '../../css/rich-text-view-quill.scss'

interface RichTextViewProps {
  html: string | null | undefined
  className?: string
  fallback?: React.ReactNode
}

/**
 * Returns true when a rich-text value has no visible content. 
 * fallback in lists and badges.
 */
export function isRichTextEmpty(html: string | null | undefined): boolean {
  const normalized = (html ?? '').trim()
  return (
    normalized === '' ||
    normalized === '<p><br></p>' ||
    normalized === '<p></p>'
  )
}

/**
 * Renders HTML from {@link RichTextEditor}. The wrapper uses `ql-editor` so
 * Quill Snow CSS (indent, lists, etc.) applies; `gw-rich-text-view--readonly`
 * removes editor-only chrome via `rich-text-view-quill.scss`.
 */
export function RichTextView({
  html,
  className,
  fallback = null,
}: RichTextViewProps) {
  if (isRichTextEmpty(html)) {
    return <>{fallback}</>
  }

  return (
    <div
      className={`ql-editor gw-rich-text-view gw-rich-text-view--readonly${
        className ? ` ${className}` : ''
      }`}
      dangerouslySetInnerHTML={{ __html: (html ?? '').trim() }}
    />
  )
}

export default RichTextView
